import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';
import BlankLayout from '../../../../components/layout/BlankLayout';
import ConfirmPageAsync from './component/confirmpage/async';

export default [
  <Route
    key="/business/user/free-trial"
    element={<BlankLayout showContactSales={false} demostorebutton={false} />}
  >
    <Route path="business/user/free-trial" element={<AsyncPage />} />
  </Route>,
  // TODO(v6 migration): optional enum ":subscriptionType(premium|essential|basic)?"
  // is unsupported in v6. Needs splitting into explicit routes, e.g.
  // "business/user/sign-up" and "business/user/sign-up/:subscriptionType".
  // Left as a permissive optional param for now.
  <Route
    key="/business/user/sign-up/:subscriptionType(premium|essential|basic)?"
    element={<BlankLayout showContactSales={false} demostorebutton={false} />}
  >
    <Route
      path="business/user/sign-up/:subscriptionType?"
      element={<AsyncPage />}
    />
  </Route>,
  <Route
    key="/business/user/signup-confirmed"
    element={<BlankLayout showContactSales={false} demostorebutton={false} />}
  >
    <Route
      path="business/user/signup-confirmed"
      element={<ConfirmPageAsync />}
    />
  </Route>,
];
